import axiosInstance from "../../lib/axiosInstance";
import { getErrorMessage } from "../../utils/errorUtils";
import {
  setLoadingUnallocated,
  setUnallocatedPayments,
  setErrorLoadingUnallocated,
  setUnallocatedPagination,
} from "../slices/unallocatedPayment";

export const getUnallocatedPayments =
  ({ page = 1, size = 10, search = "", startDate = "", endDate = "" }) =>
  async (dispatch) => {
    dispatch(setLoadingUnallocated());
    try {
      const params = { page, size, startDate, endDate };
      if (search) params.search = search;

      const { data } = await axiosInstance.get("/unallocated-payments", {
        params,
        headers: { requiresAuth: true },
      });

      if (data.status === "SUCCESS") {
        dispatch(setUnallocatedPayments(data.data.content));
        dispatch(setUnallocatedPagination(data.data.pagination));
      }
    } catch (error) {
      dispatch(setErrorLoadingUnallocated(getErrorMessage(error)));
    }
  };
